import { Component, Input, OnChanges } from '@angular/core';
import { FluentIconService } from './fluent-icon.service';
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

@Component({
  selector: 'app-file-icon',
  standalone: true,
  template: `<span [innerHTML]="svgIcon"></span>`,
  styles: [`
    span svg {
      width: 24px;
      height: 24px;
      vertical-align: middle;
    }
  `]
})
export class FileIconComponent implements OnChanges {
  @Input() fileName: string = '';
  svgIcon: SafeHtml = '';

  constructor(private fileIconService: FluentIconService, private readonly sanitizer: DomSanitizer) { }

  ngOnChanges() {
    this.svgIcon = this.getFileIcon(this.fileName);
  }

  getFileIcon(fileName: string): SafeHtml {
    const iconName = this.fileIconService.getFileIconName(fileName);
    const svgContent = this.fileIconService.getSvgContent(iconName);
    return this.sanitizer.bypassSecurityTrustHtml(svgContent);
  }
}
